export function InlineSpinner() {
  return <span className={"spinner-border spinner-border-sm me-2"}></span>;
}
